import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';
const MessagesIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M10.767 8.698H5.633L2.7 11.5V8.698H1.233A.733.733 0 0 1 .5 7.965V1.233A.733.733 0 0 1 1.233.5h9.534a.733.733 0 0 1 .733.733v6.732a.733.733 0 0 1-.733.733Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default MessagesIcon;